export class AudioAssetResolver {
  private baseUrl: string = '/audio';

  initialize(audioBaseUrl: string): void {
    this.baseUrl = audioBaseUrl.replace(/\/+$/, '') || '/audio';
  }

  resolve(language: string, style: string, number: number): string {
    return `${this.baseUrl}/${language}/${style}/${number}.mp3`;
  }

  resolvePreview(language: string, style: string, previewUrl: string | null): string | null {
    if (!previewUrl) return null;
    // If previewUrl is absolute, return as-is
    if (/^https?:\/\//.test(previewUrl)) return previewUrl;
    // If relative, it's relative to origin, return as-is
    if (previewUrl.startsWith('/')) return previewUrl;
    // Otherwise prepend base URL
    return `${this.baseUrl}/${language}/${style}/${previewUrl}`;
  }

  isExternalOrigin(): boolean {
    return /^https?:\/\//.test(this.baseUrl);
  }

  getBaseUrl(): string {
    return this.baseUrl;
  }
}
